import styled from "styled-components";
import useGame from "../../modules/game/hooks/use-game";
import TaskLink from "./task-link";
import mapImage from '../../assets/mapa/mapa.jpg';
import mapImage2 from '../../assets/mapa/mapa-layer-2.png';
import { useState, useCallback, useEffect, useMemo } from "react";
import './style.scss';
import Path from "./path";
import useUser from "../../modules/user/hooks/use-user";
import EndGamePopup from "../end-game-popup";
import { getRulesRoute } from "../../routes/routes";
import { Link } from "react-router-dom";

type Props = {

}

type ContainerProsp = {
    scroll: 'horizontal' | 'vertical',
    windowWidth: number,
    windowHeight: number,
    pageRatio: number
}

const Container = styled.div<ContainerProsp>`
    width: 100%;
    /* min-height: 100vh; */

    ${({ scroll }) => {
        if (scroll === 'horizontal') {
            return `
                overflow-x: scroll;
                overflow-y: hidden;
                height: 100%;
            `;
        }
    }}

    position: relative;

    .inner {
        position: relative;

        transition: all .5s;

        ${({ scroll, windowHeight, pageRatio }) => {
        if (scroll === 'horizontal') {
            return `
                    padding-top: 0;
                    width: ${windowHeight * (1 / pageRatio)}px;
                    height: ${windowHeight}px;
                `;
        }
        if (scroll === 'vertical') {
            return `
                width: 100%;
                padding-top: ${pageRatio * 100}%;
            `;
        }
    }}
    }

    .map {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        background: url(${mapImage}) 50% 50% no-repeat;
        background-size: cover;
    }

    .layer-2 {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        background: url(${mapImage2}) 50% 50% no-repeat;
        background-size: cover;
        pointer-events: none;
    }
`;

const MapComponent: React.FC<Props> = () => {

    const { taskIds } = useGame();
    const { user, libraryCode } = useUser();

    const pageRatio = 1200 / 1920;

    const [scroll, setScroll] = useState<ContainerProsp['scroll']>('vertical');
    const [windowWidth, setWindowWidth] = useState(0);
    const [windowHeight, setWindowHeight] = useState(0);
    const [mapHeight, setMapHeight] = useState(0);

    const onResize = useCallback(() => {
        const windowRatio = window.innerHeight / window.innerWidth;

        if (windowRatio < pageRatio) {
            setScroll('vertical');
            setMapHeight(window.innerWidth * pageRatio)
        } else {
            setScroll('horizontal');
            setMapHeight(window.innerHeight)
        }

        setWindowWidth(window.innerWidth);
        setWindowHeight(window.innerHeight);
    }, [setScroll, setWindowWidth, setWindowHeight, pageRatio, setMapHeight])

    useEffect(() => {
        window.addEventListener('resize', onResize);
        window.addEventListener('scroll', onResize);
        onResize();

        return () => {
            window.removeEventListener('resize', onResize);
            window.removeEventListener('scroll', onResize);
        }
    }, [onResize]);

    const gameCompleted = useMemo(() => {
        return ['t-306', 't-406', 't-206', 't-106'].every(id => {
            return user?.completedTasks.includes(id);
        });
    }, [user]);

    const [showEndGame, setShowEndGame] = useState(gameCompleted);

    return <Container
        scroll={scroll}
        windowWidth={windowWidth}
        windowHeight={windowHeight}
        className={scroll}
        pageRatio={pageRatio}
    >
        <div className="inner">
            <div className="map" style={{ fontSize: `${mapHeight}px` }}>

                <Path id='path-1-1' requires='t-101' />
                <Path id='path-1-2' requires='t-102' />
                <Path id='path-1-3' requires='t-103' />
                <Path id='path-1-4' requires='t-104' />
                <Path id='path-1-5' requires='t-105' />
                <Path id='path-1-6' requires='t-106' />
                <Path id='path-1-7' requires='t-106' />
                <Path id='path-1-award' requires='t-106' />

                <Path id='path-2-1' requires='t-201' />
                <Path id='path-2-2' requires='t-202' />
                <Path id='path-2-3' requires='t-203' />
                <Path id='path-2-4' requires='t-204' />
                <Path id='path-2-5' requires='t-205' />
                <Path id='path-2-6' requires='t-206' />
                <Path id='path-2-7' requires='t-206' />
                <Path id='path-2-award' requires='t-206' />

                <Path id='path-3-1' requires='t-401' />
                <Path id='path-3-2' requires='t-402' />
                <Path id='path-3-3' requires='t-403' />
                <Path id='path-3-4' requires='t-404' />
                <Path id='path-3-5' requires='t-405' />
                <Path id='path-3-6' requires='t-406' />
                <Path id='path-3-7' requires='t-406' />
                <Path id='path-3-award' requires='t-406' />

                <Path id='path-4-1' requires='t-301' />
                <Path id='path-4-2' requires='t-302' />
                <Path id='path-4-3' requires='t-303' />
                <Path id='path-4-4' requires='t-304' />
                <Path id='path-4-5' requires='t-305' />
                <Path id='path-4-6' requires='t-306' />
                <Path id='path-4-7' requires='t-306' />
                <Path id='path-4-award' requires='t-306' />

                {
                    taskIds.map(tId => {
                        return <TaskLink key={tId} id={tId} />
                    })
                }


                <div className="layer-2"></div>
                <Link className="rules-link" to={getRulesRoute()}>Instrukcja</Link>
            </div>
        </div>
        {/*
            <h2>Postep ścieżek</h2>
            <div className="paths">
            {
                pathIds.map(p => {
                    return <Path key={p} id={p} />
                })
            }
        </div> */}

        {
            showEndGame && libraryCode && <EndGamePopup onClose={() => {setShowEndGame(false)}} libCode={libraryCode} />
        }

    </Container>
}

export default MapComponent;
